import { render, staticRenderFns } from "./QrCodeApp.vue?vue&type=template&id=052eac4c&scoped=true&"
import script from "./QrCodeApp.vue?vue&type=script&lang=js&"
export * from "./QrCodeApp.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeApp.vue?vue&type=style&index=0&id=052eac4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052eac4c",
  null
  
)

export default component.exports